<template>
  <div>
    <div class="errorWrap">
      <div class="errorImg"></div>
      <p class="errorText">
        로그인 시간이 만료되었습니다.<br>
        <span>다시 로그인 해주세요.</span>
      </p>
    </div>
    <div class="errorBottomBtn" @click="backBtn">확인</div>
  </div>
</template>

<script>
export default {
  mounted () {
    window.backBtn = () => {
      this.backBtn()
    }
    localStorage.removeItem('Authorization')
  },
  methods: {
    backBtn () {
      this.$router.replace({ name: 'AppLogin' })
    }
  }
}
</script>

<style scoped>
</style>
